export const RouteConstants = {
  BASE: "/",
  EMAIL_LISTS: {
    BROWSE: "/email-lists/browse",
    UPLOAD: "/email-lists/upload"
  },
  MARKETING_CAMPAIGN: {
    BROWSE: "/marketing-campaign/browse",
    CREATE: "/marketing-campaign/create"
  },
  LOGIN: {
    CALLBACK: "/login/callback",
    INITIATE: "/login/initiate"
  },
  WILDCARD: "*"
};
